"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformChargebackStatusToString = transformChargebackStatusToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformChargebackStatusToString(orderStatus) {
    switch (orderStatus) {
        case legacy_enums_1.ChargebackStatus.Fulfilled:
            return "fulfilled";
        case legacy_enums_1.ChargebackStatus.Failed:
            return "failed";
        case legacy_enums_1.ChargebackStatus.Pending:
            return "pending";
        default:
            return "unknown";
    }
}
//# sourceMappingURL=transformChargebackStatusToString.js.map